import { render, staticRenderFns } from "./vendor-row.vue?vue&type=template&id=120eac06"
import script from "./vendor-row.vue?vue&type=script&setup=true&lang=js"
export * from "./vendor-row.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports